import { useCallback, useEffect, useState } from 'react'
import { logError } from 'utils'

export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    return getLocalStorageValue(initialValue, key)
  })

  useEffect(() => {
    setStoredValue(initialValue => getLocalStorageValue(initialValue, key))
  }, [key])

  const setValue = useCallback(
    value => {
      setStoredValue(storedValue => {
        try {
          const valueToStore = value instanceof Function ? value(storedValue) : value
          if (typeof window !== 'undefined') {
            window.localStorage.setItem(key, JSON.stringify(valueToStore))
          }
          return valueToStore
        } catch (error) {
          if (error) logError(error)
        }
      })
    },
    [key]
  )
  return [storedValue, setValue]
}

const getLocalStorageValue = (initialValue, key) => {
  if (typeof window === 'undefined') {
    return initialValue
  }
  try {
    const item = window.localStorage.getItem(key)
    return item ? JSON.parse(item) : initialValue
  } catch (error) {
    if (error) logError(error)
    return initialValue
  }
}
